export class BufferingAbortedError extends Error {
    override name = 'BufferingAbortedError';
    classType: string;
    parentIndex: number | undefined;

    constructor(classType: string, parentIndex: number | undefined, reason: string) {
        super('Aborted buffering because ' + reason);
        // Re-anchor prototype: defends against runtime Error wrappers (extensions,
        // third-party scripts) that break super()'s new.target semantics.
        Object.setPrototypeOf(this, BufferingAbortedError.prototype);
        this.classType = classType;
        this.parentIndex = parentIndex;
    }
}

export class FailedToLoadError extends Error {
    #metadata = {};

    constructor(message: string, metadata = {}) {
        super(message);
        Object.setPrototypeOf(this, FailedToLoadError.prototype);
        this.#metadata = metadata;
    }

    get metadata() {
        return this.#metadata;
    }
}
